import React, { useEffect, useMemo, useState } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Sector } from 'models/sector';
import { TravelStatus } from 'models/travelStatus';

import FlightDetails from '../FlightDetails';
import SimpleTabs from '../SimpleTabs';
import { Content } from './styles';

type Props = {
  sectors: Sector[];
  exchangedSectors?: Sector[];
  status: TravelStatus;
  onCancel?: () => void;
  exchangeConfirmed?: boolean;
  exchangePending?: boolean;
  selectedTab: string;
};
const SectorDetails = ({
  sectors,
  exchangedSectors,
  status,
  onCancel,
  exchangeConfirmed,
  exchangePending,
  selectedTab,
}: Props) => {
  const { t } = useStoreTranslation();
  const [tab, setTab] = useState(selectedTab);
  useEffect(() => {
    setTab(selectedTab);
  }, [selectedTab]);
  const exchangeStatus = useMemo(() => {
    if (exchangeConfirmed) return TravelStatus.Confirmed;
    if (exchangePending) return TravelStatus.ExchangePending;
    return undefined;
  }, [exchangeConfirmed, exchangePending]);
  return (
    <Content>
      {exchangedSectors && exchangedSectors.length > 0 && (
        <SimpleTabs
          options={[
            { label: t('flightDetails.section.detail.tabs.current'), value: '1' },
            { label: t('flightDetails.section.detail.tabs.exchange'), value: '2', alert: true },
          ]}
          onChange={(value) => setTab(value)}
          selected={tab}
        />
      )}
      {tab === '1' ? (
        <>
          {sectors.map((sector) => (
            <FlightDetails
              key={`sector-${sector.sectorNumber}`}
              sector={sector}
              status={status}
              isDeparture={sector.sectorNumber === 1}
              isMultidestination={sectors.length > 2}
            />
          ))}
        </>
      ) : (
        <>
          {exchangedSectors &&
            exchangedSectors.map((sector) => (
              <FlightDetails
                key={`sector-${sector.sectorNumber}`}
                sector={sector}
                status={exchangeStatus ?? status}
                canCancel={status !== TravelStatus.Confirmed ? true : false}
                onCancel={onCancel}
              />
            ))}
        </>
      )}
    </Content>
  );
};
export default SectorDetails;
